<label *ngIf="label" [for]="labelId">{{ label }}</label>
<textarea
  [id]="labelId"
  [formControl]="control"
  class="form-control"
  [attr.disabled]="disabled"
  [readonly]="readonly"
  rows="4"
></textarea>
<div *ngIf="countCharacters" class="mt-1 text-small d-flex white50">
  <div class="text-sm-start" *ngIf="minCharacters">
    Min. {{ minCharacters }} characters
  </div>
  <div class="text-sm-end flex-grow-1">{{ control.value?.trim().length }}{{ maxCharacters ? ' / ' + maxCharacters : '' }}</div>
</div>
